const AdditionalInfo = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M10.0007 1.66662C5.39828 1.66662 1.66732 5.39757 1.66732 9.99995C1.66732 14.6023 5.39828 18.3333 10.0007 18.3333C14.603 18.3333 18.334 14.6023 18.334 9.99995C18.334 5.39758 14.603 1.66662 10.0007 1.66662Z"
      stroke="#444444"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.0005 13.3333L10.0005 9.99995"
      stroke="#444444"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.0005 6.66672L9.99215 6.66672"
      stroke="#444444"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default AdditionalInfo;
